import React from 'react'
import './TagContainer.scss'
import classNames from 'classnames'

// type options 
//  'neutral',
//  'informative1',
//  'informative2',
//  'positive',
//  'negative',
//  'warning',
//  'inverse', 

const TagContainer = ({ text, type =  'neutral' }) => {
  return <div className={classNames('tag-container', 'tag-container--' + type)}>{text}</div>
}

export default TagContainer
